import API from "../interceptor/axios.interceptor.service";

class LeadTimeOptionsBackendApiService {
    static async getLeadTimeOptions() {
        const url = `/api/v1/lead-times/options`;
        try {
            const response = await API.get(url);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong while fetching the lead times options!',
            }
        }
    }

    static async updateLeadTimeOptions(payload) {
        const url = `/api/v1/lead-times/options`;
        try {
            const response = await API.post(url, payload);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong while updating the list of lead time options!',
            }
        }
    }
}

export default LeadTimeOptionsBackendApiService;
